export default "__VITE_ASSET__BqbAFQAt__"